import React from "react";
import { withTranslation } from "react-i18next";

import {Alert, Col, Container, Row, Table, Card, Badge, Form} from "react-bootstrap";
import QrCodeScanner from "../../../../components/qrCodeScanner/QrCodeScanner";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleNotch, faRedo} from "@fortawesome/free-solid-svg-icons";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import APIErrorHelper from "../../../../helpers/APIErrorHelper";
import Editor from "react-simple-code-editor";
import {highlight, languages} from "prismjs/components/prism-core";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import Switch from "react-switch";

class RemoteAttestationTab extends React.Component {
  constructor(props) {
    super(props);
    this.tableId = "replacementDevicesTable";

    this.state = {
      scannerIsRunning: false,
      registerIsRunning: false,
      policyUpdateIsRunning: false,
      registerDevice: null,
      stagedDevice: null,
      policy: null,
      policyString: "",
      dialogApiError: "",
      raLogs: [],
      lastReload: new Date().toISOString(),
      apiError: "",
      apiErrorTop: ""
    };

    this.loadData               = this.loadData.bind(this);
    this.handleScanStart        = this.handleScanStart.bind(this);
    this.handleScanResult       = this.handleScanResult.bind(this);
    this.handleScanValidation   = this.handleScanValidation.bind(this);
    this.handleRegisterDevice   = this.handleRegisterDevice.bind(this);
    this.handlePolicyChange     = this.handlePolicyChange.bind(this);
    this.handlePolicyUpdate     = this.handlePolicyUpdate.bind(this);
    this.loadRaLogs             = this.loadRaLogs.bind(this);

    this.scannerRef = React.createRef();
  }

  async componentDidMount() {
    await this.loadData();
  }

  async loadData() {
    try {
      const replacementDevices = await CamplaCoreService.getAllReplacementDevices();
      this.setState({replacementDevices});
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
            err,
            () => this.setState({ apiError: "" }),
            {},
            this.props.t)
      });
    }
    try {
      const policy = await CamplaCoreService.getDevicePolicy();
      const policyString = JSON.stringify({
        runtime_policy: policy.runtime_policy,
        mb_refstate: policy.mb_refstate
      }, null, 2)
      this.setState({policy, policyString});
    } catch (err) {
      if (err.status === "404"){
        const policyString = JSON.stringify({
          runtime_policy: {},
          mb_refstate: {}
        }, null, 2)
        this.setState({policy: null, policyString});
      }
    }
  }

  handlePolicyChange(policyString, active){
    const updatedPolicy = {
          policy_id: this.state.policy ? this.state.policy.policy_id : null,
          active: active,
          runtime_policy: this.state.policy ? this.state.policy.runtime_policy : null,
          mb_refstate: this.state.policy ? this.state.policy.mb_refstate : null
    }
    this.setState({policy: updatedPolicy, policyString})
  }

  async handlePolicyUpdate(){
    this.setState({policyUpdateIsRunning: true });

    try {
      const newPolicy = JSON.parse(this.state.policyString);
      if (ValidationHelper.isKeylimePolicy(newPolicy)){
        try {
          const policy = await CamplaCoreService.setDevicePolicy({
            runtime_policy: newPolicy.runtime_policy,
            mb_refstate: newPolicy.mb_refstate
          });
          const policyString = JSON.stringify({
            runtime_policy: policy.runtime_policy,
            mb_refstate: policy.mb_refstate
          }, null, 2)
          if (this.state.policy.active){
            await CamplaCoreService.activateDevicePolicy();
          }else{
            await CamplaCoreService.deactivateDevicePolicy();
          }
          policy["active"] = this.state.policy.active;
          this.setState({policy, policyString});
        } catch (err) {
          this.setState({
            apiErrorTop: APIErrorHelper.getError(
                err,
                () => this.setState({apiErrorTop: ""}),
                {},
                this.props.t)
          });
        }
      }else{
        this.setState({
          apiErrorTop: APIErrorHelper.getError(
              {status: 412},
              () => this.setState({ apiErrorTop: "" }),
              {},
              this.props.t)
        });
      }
    }catch (err){
      this.setState({
        apiErrorTop: APIErrorHelper.getError(
            {status: 412},
            () => this.setState({ apiErrorTop: "" }),
            {},
            this.props.t)
      });
    }

    this.setState({policyUpdateIsRunning: false});
  }

  handleScanStart(callback) {
    this.setState({ scannerIsRunning: true, stagedDevice: null, registerDevice: null }, callback);
  }

  async handleRegisterDevice(device){
    this.setState({registerIsRunning: true, stagedDevice: null });
    try {
      const res = await CamplaCoreService.registerMemberDevice({id: device.t.id, token: device.t.token});
      device["status"] = res.status;
      this.setState({registerDevice: device});
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
            err,
            () => this.setState({ apiError: "" }),
            {},
            this.props.t)
      });
    }
    this.setState({registerIsRunning: false});
  }

  async handleScanResult(res) {
    const device = JSON.parse(res);
    device["isolationHardware"] = null;
    try {
      const isolationHardware = await CamplaCoreService.getIsolationHardwareBySerialNumber(device.s);
      device["isolationHardware"] = isolationHardware;
    } catch (err) {}
    this.setState({ stagedDevice: device, scannerIsRunning: false });
  }


  handleScanValidation(res){
    try {
      const device = JSON.parse(res);
      return typeof device["i"] !== "undefined"
          && typeof device["s"] !== "undefined"
          && typeof device["t"] !== "undefined"
    }catch (err){}
    return false;
  }

  async loadRaLogs(){
    try {
      const logs = await CamplaCoreService.getDeviceLogs();
      this.setState({raLogs: logs, lastReload: new Date().toISOString()});
    } catch (err) {
      //Todo: Add correct errors according to documentation
      this.setState({
        apiError: APIErrorHelper.getError(
            err,
            () => this.setState({ apiError: "" }),
            {},
            this.props.t
        )
      });
    }
  }


  render() {
    const { t } = this.props;
    const logs = this.state.raLogs
        .filter(line => line !== "")
        .reverse()
        .map(line => {
          const lineParts = line.split(" - ");
          if (lineParts.length > 1){
            return <><span><b style={{color: "green"}}>{lineParts[0]}</b> - {lineParts[1]}</span><br /></>
          }else{
            return <><span>{line}</span><br /></>
          }
        });

    return (
        <div>
          <Container className="mt-3 pl-0 pr-0">
            {this.state.apiErrorTop ? (
                <Row>
                  <Col>{this.state.apiErrorTop}</Col>
                </Row>
            ) : ""}
            <Row className="pageTitle">
              <Col>
                <h2>{t("Hardware.Tabs.RemoteAttestation.Title")}</h2>
              </Col>
              <Col>
                <QrCodeScanner
                    className="floatRight"
                    content={<span>{t("Hardware.Tabs.RemoteAttestation.RegisterDevice")}</span>}
                    previewRef={this.scannerRef}
                    validator={this.handleScanValidation}
                    onScannerStart={this.handleScanStart}
                    onScannerStop={() => {}}
                    onScannerError={() => {}}
                    onScannerResult={this.handleScanResult} />
              </Col>
            </Row>
            <Row>
              <Col>
                {t("Hardware.Tabs.RemoteAttestation.Description")}
              </Col>
            </Row>
            {this.state.apiError ? (
                <Row>
                  <Col>{this.state.apiError}</Col>
                </Row>
            ) : ""}
            {this.state.scannerIsRunning ? (
                <Row className="mt-3">
                  <Col>
                    <div style={{textAlign: "center", width: "100%"}}>
                      <video ref={this.scannerRef} width={600} />
                    </div>
                  </Col>
                </Row>
            ) : ""}
            {this.state.stagedDevice ? (
                <Row className="mt-3">
                  <Col>
                    <Card>
                      <Card.Body>
                        {!this.state.stagedDevice.isolationHardware ? (
                            <Alert variant="warning">
                              {t("Hardware.Tabs.RemoteAttestation.UnknownStageStick")}
                            </Alert>
                        ) : "" }
                        <Table size="sm">
                          {this.state.stagedDevice.isolationHardware ? (
                              <tbody>
                              <tr>
                                <td style={{width: "180px"}}>
                                  <b>{t("Hardware.Tabs.RemoteAttestation.StageModel")}</b>
                                </td>
                                <td>{this.state.stagedDevice.t.name}</td>
                              </tr>
                              <tr>
                                <td style={{width: "180px"}}>
                                  <b>{t("Hardware.Tabs.RemoteAttestation.StageStickStatus")}</b></td>
                                <td>
                                  <h5>
                                    <Badge className="btn-green">
                                      {t("Hardware.Tabs.RemoteAttestation.StageStickStatusRegistered")}
                                    </Badge>
                                  </h5>
                                </td>
                              </tr>
                              <tr>
                                <td style={{width: "180px"}}>
                                  <b>{t("Hardware.Tabs.RemoteAttestation.StageStickIdentifier")}</b></td>
                                <td><b>{this.state.stagedDevice.isolationHardware.identifier}</b></td>
                              </tr>
                              <tr>
                                <td style={{width: "180px"}}>
                                  <b>{t("Hardware.Tabs.RemoteAttestation.StageStickProduct")}</b></td>
                                <td><b>{this.state.stagedDevice.isolationHardware.product}</b></td>
                              </tr>
                              <tr>
                                <td style={{width: "180px"}}>
                                  <b>{t("Hardware.Tabs.RemoteAttestation.StageStickSerial")}</b></td>
                                <td><b>{this.state.stagedDevice.s}</b></td>
                              </tr>
                              </tbody>
                          ) : (
                              <tbody>
                              <tr>
                                <td style={{width: "180px"}}>
                                  <b>{t("Hardware.Tabs.RemoteAttestation.StageModel")}</b>
                                </td>
                                <td>{this.state.stagedDevice.t.name}</td>
                              </tr>
                              <tr>
                                <td style={{width: "180px"}}>
                                  <b>{t("Hardware.Tabs.RemoteAttestation.StageStickStatus")}</b></td>
                                <td>
                                  <h5>
                                    <Badge className="btn-red">
                                      {t("Hardware.Tabs.RemoteAttestation.StageStickStatusUnknown")}
                                    </Badge>
                                  </h5>
                                </td>
                              </tr>
                              <tr>
                                <td style={{width: "180px"}}>
                                  <b>{t("Hardware.Tabs.RemoteAttestation.StageStickSerial")}</b></td>
                                <td>{this.state.stagedDevice.s}</td>
                              </tr>
                              </tbody>
                          )}
                        </Table>
                        <Button
                            className="btn btn-green floatRight"
                            onClick={() => this.handleRegisterDevice(Object.assign({}, this.state.stagedDevice))}
                        >
                          {t("Hardware.Tabs.RemoteAttestation.StageAccept")}
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
            ) : ""}
            {this.state.registerIsRunning ? (
                <Row className="mt-3">
                  <Col>
                    <h3><FontAwesomeIcon icon={faCircleNotch} spin /> {t("Hardware.Tabs.RemoteAttestation.Register")}</h3>
                  </Col>
                </Row>
            ) : ""}
            {this.state.registerDevice ? (
                <Row className="mt-3">
                  <Col>
                    {this.state.registerDevice.status ? (
                        <Alert variant="success">
                          {t("Hardware.Tabs.RemoteAttestation.RegisterSuccessful")}
                        </Alert>) : (
                        <Alert variant="danger">
                          {t("Hardware.Tabs.RemoteAttestation.RegisterFailed")}
                        </Alert>)}
                  </Col>
                </Row>
            ) : ""}
            <Row className="mt-3">
              <Col>
                <h4>{t("Hardware.Tabs.RemoteAttestation.RALogs")}</h4>
              </Col>
              <Col>
                <div style={{float: "right", fontSize: "10pt"}}>
                  ({this.state.lastReload}) <FontAwesomeIcon icon={faRedo} onClick={() => this.loadRaLogs()}/>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={{
                  height: "400px",
                  backgroundColor: "black",
                  color: "white",
                  fontSize: "9pt",
                  overflow: "auto",
                  display: "flex",
                  flexDirection: "column-reverse"
                }}>
                  {logs}
                </div>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <h4>{t("Hardware.Tabs.RemoteAttestation.KeylimePolicy.Title")}</h4>
              </Col>
              <Col>
                <div className="floatRight">
                  <Button
                      className="btn btn-green"
                      disabled={this.state.policyUpdateIsRunning}
                      onClick={() => this.handlePolicyUpdate()}
                  >
                    {t("Hardware.Tabs.RemoteAttestation.KeylimePolicy.Form.Save")}{" "}
                    {this.state.policyUpdateIsRunning && (<FontAwesomeIcon icon={faCircleNotch} spin /> )}
                  </Button>
                </div>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <Form.Group controlId="formBasicAllowStudentFiles">
                  <Form.Label>
                    <b>{t(
                        "Hardware.Tabs.RemoteAttestation.KeylimePolicy.Form.TogglePolicyActivation"
                    )}</b>
                  </Form.Label>
                  <Switch
                      className="float-right"
                      onColor="#54BF8D"
                      disabled={this.state.policyUpdateIsRunning}
                      checked={this.state.policy ? this.state.policy.active : false}
                      onChange={state => this.handlePolicyChange(this.state.policyString, state)}
                      height={18}
                      width={40}
                  />
                </Form.Group>
                <div className="container_editor_area">
                  <Editor
                      placeholder={t(
                          "Hardware.Tabs.RemoteAttestation.KeylimePolicy.Form.ConfigurationPlaceholder"
                      )}
                      value={this.state.policyString}
                      onValueChange={code => this.handlePolicyChange(code,
                          (this.state.policy ? this.state.policy.active : false))}
                      highlight={code => highlight(code, languages.json)}
                      padding={10}
                      className="container__editor"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
    );
  }
}

export default withTranslation()(RemoteAttestationTab);
